import { useId } from "react";
import Container from "../Container";
import * as S from "./styles";

type Props = {
  label?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  disabled?: boolean;
  stopPropagation?: boolean;
  className?: string;
};

const CustomCheckbox = ({
  onChange,
  checked,
  label,
  disabled,
  stopPropagation,
  className,
}: Props) => {
  // The label text renders outside CheckboxWrapper (itself the <label>) so that a
  // long, wrapping label is not clipped by the wrapper's fixed height. Without an
  // explicit for/id pair that leaves the text inert, so only the 16px box toggles.
  const inputId = useId();

  return (
    <Container className={className} padding="0" gap={1} flat>
      <S.CheckboxWrapper
        className={disabled ? "disabled" : ""}
        htmlFor={inputId}
        onClick={(e) => stopPropagation && e.stopPropagation()}>
        <S.CheckboxInput
          id={inputId}
          type="checkbox"
          onChange={onChange}
          checked={checked}
          disabled={disabled}
        />
        <S.Checkmark>
          <S.CheckmarkTick />
        </S.Checkmark>
      </S.CheckboxWrapper>
      {label && (
        <S.CheckboxLabel
          htmlFor={inputId}
          className={disabled ? "disabled" : ""}
          onClick={(e) => stopPropagation && e.stopPropagation()}>
          {label}
        </S.CheckboxLabel>
      )}
    </Container>
  );
};

export default CustomCheckbox;
